import { Button, Icon } from '@/ui';
import { useCustomizeMode } from './useCustomizeMode';

export const CustomizeButton = () => {
  const { enterCustomizeMode } = useCustomizeMode();

  return (
    <Button
      borderRadius="ah-lg"
      leftIcon={<Icon icon="Sliders" size={4} />}
      size="ah"
      variant="ahOutline"
      onClick={enterCustomizeMode}
    >
      Customize
    </Button>
  );
};
